var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-quantity-dropdown.j2"] = require( "macros/product-quantity-dropdown.j2" );
dependencies["registry-quickshop/registry-quickshop-name.j2"] = require( "registry-quickshop/registry-quickshop-name.j2" );
dependencies["product-quantity.j2"] = require( "product-quantity.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-registry-quantity.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-quantity-dropdown.j2", false, "product/templates/product-registry-quantity.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("productQuantityDropdown")) {
var t_4 = t_1.productQuantityDropdown;
} else {
cb(new Error("cannot import 'productQuantityDropdown'")); return;
}
context.setVariable("productQuantityDropdown", t_4);
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "innerProduct")),"isEgiftCard") && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "innerProduct")),"isGiftCard")) {
env.getTemplate("registry-quickshop/registry-quickshop-name.j2", false, "product/templates/product-registry-quantity.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
var t_9;
t_9 = (lineno = 6, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.productRegistry.selectedItem"]));
frame.set("selectedItem", t_9, true);
if(frame.topLevel) {
context.setVariable("selectedItem", t_9);
}
if(frame.topLevel) {
context.addExport("selectedItem", t_9);
}
var t_10;
t_10 = (lineno = 7, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["selectedItem.purchased_quantity",0]));
frame.set("purchased", t_10, true);
if(frame.topLevel) {
context.setVariable("purchased", t_10);
}
if(frame.topLevel) {
context.addExport("purchased", t_10);
}
var t_11;
t_11 = (lineno = 8, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["selectedItem.requested_quantity",0]));
frame.set("requested", t_11, true);
if(frame.topLevel) {
context.setVariable("requested", t_11);
}
if(frame.topLevel) {
context.addExport("requested", t_11);
}
var t_12;
t_12 = env.getFilter("int").call(context, (lineno = 10, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["registry.requestedQuantity",0])));
frame.set("selectedRequested", t_12, true);
if(frame.topLevel) {
context.setVariable("selectedRequested", t_12);
}
if(frame.topLevel) {
context.addExport("selectedRequested", t_12);
}
var t_13;
t_13 = env.getFilter("int").call(context, (lineno = 11, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["registry.purchasedQuantity",0])));
frame.set("selectedPurchased", t_13, true);
if(frame.topLevel) {
context.setVariable("selectedPurchased", t_13);
}
if(frame.topLevel) {
context.addExport("selectedPurchased", t_13);
}
var t_14;
t_14 = (runtime.contextOrFrameLookup(context, frame, "selectedRequested") > -1?runtime.contextOrFrameLookup(context, frame, "selectedRequested"):runtime.contextOrFrameLookup(context, frame, "requested"));
frame.set("desiredQuantity", t_14, true);
if(frame.topLevel) {
context.setVariable("desiredQuantity", t_14);
}
if(frame.topLevel) {
context.addExport("desiredQuantity", t_14);
}
var t_15;
t_15 = (runtime.contextOrFrameLookup(context, frame, "selectedPurchased") > -1?runtime.contextOrFrameLookup(context, frame, "selectedPurchased"):runtime.contextOrFrameLookup(context, frame, "purchased"));
frame.set("alreadyBought", t_15, true);
if(frame.topLevel) {
context.setVariable("alreadyBought", t_15);
}
if(frame.topLevel) {
context.addExport("alreadyBought", t_15);
}
var t_16;
t_16 = runtime.contextOrFrameLookup(context, frame, "desiredQuantity") - runtime.contextOrFrameLookup(context, frame, "alreadyBought");
frame.set("remaining", t_16, true);
if(frame.topLevel) {
context.setVariable("remaining", t_16);
}
if(frame.topLevel) {
context.addExport("remaining", t_16);
}
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"ownerView")) {
output += "<div class=\"o-row o-column o-extra-small--12\">\n\n            <div class=\"o-column o-extra-small--6 o-medium--4 c-registry-quickshop__select\">\n\n                <div class=\"c-form__field\">\n\n                    <label class=\"c-form__label\" for=\"registry-quantity-selection\">\n\n                        ";
output += runtime.suppressValue((lineno = 27, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_registry-requested-quantity"])), env.opts.autoescape);
output += ":\n\n                    </label>\n\n                    ";
output += runtime.suppressValue((lineno = 31, colno = 44, runtime.callWrap(t_4, "productQuantityDropdown", context, [runtime.makeKeywordArgs({"id": "registry-quantity-selection","class": "js-quickshop-registry__requested-quantity","desiredQuantity": runtime.contextOrFrameLookup(context, frame, "desiredQuantity"),"startingIndex": runtime.contextOrFrameLookup(context, frame, "alreadyBought")})])), env.opts.autoescape);
output += "\n\n                </div>\n\n            </div>\n\n            <div class=\"o-column o-extra-small--6 o-medium--4\">\n\n                <div class=\"c-form__field\">\n\n                    <label class=\"c-form__label\">\n\n                        ";
output += runtime.suppressValue((lineno = 44, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_registry-remaining-quantity"])), env.opts.autoescape);
output += ":\n\n                    </label>\n\n                    ";
output += runtime.suppressValue((lineno = 48, colno = 44, runtime.callWrap(t_4, "productQuantityDropdown", context, [runtime.makeKeywordArgs({"id": "registry-quantity-selection","class": "c-registry-quickshop__owner--remaining js-quickshop-registry__remaining-quantity","dataAttributes": "data-qa-registry-remaining-qty","desiredQuantity": runtime.contextOrFrameLookup(context, frame, "remaining"),"startingIndex": 0,"max": runtime.contextOrFrameLookup(context, frame, "desiredQuantity")})])), env.opts.autoescape);
output += "\n                </div>\n\n            </div>\n\n        </div>";
;
}
else {
output += "<div class=\"o-row\">";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "selectedItem")),"outOfStock")) {
output += "<div class=\"o-column o-extra-small--6 u-no-gutters\">\n\n                    ";
env.getTemplate("product-quantity.j2", false, "product/templates/product-registry-quantity.j2", null, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
t_17.render(context.getVariables(), frame, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
output += t_18
output += "\n\n                </div>";
})});
}
output += "<div class=\"c-registry-quickshop__quantity\">\n\n                <div class=\"o-column o-extra-small--6\">\n\n                    <p class=\"c-registry-quickshop__p\">\n\n                        <span class=\"c-registry-quickshop__label\">\n\n                            ";
output += runtime.suppressValue((lineno = 81, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_registry-requested-quantity"])), env.opts.autoescape);
output += ":\n\n                        </span>\n\n                        ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "requested"), env.opts.autoescape);
output += "\n\n                    </p>\n\n                    <p class=\"c-registry-quickshop__p\">\n\n                        <span class=\"c-registry-quickshop__label\">\n\n                            ";
output += runtime.suppressValue((lineno = 93, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_registry-remaining-quantity"])), env.opts.autoescape);
output += ":\n\n                        </span>\n\n                        ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "remaining"), env.opts.autoescape);
output += "\n\n                    </p>\n\n                </div>\n\n            </div>\n\n        </div>";
;
}
})});
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-registry-quantity.j2"] , dependencies)